"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const NavContext = react_1.createContext({});
NavContext.displayName = 'NavContext';
exports.default = NavContext;
